import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useSearch = (term = null) => useQuery({ queryKey: ['search', term], queryFn: async () => {
    if(!term) return null
    const callback = await API.get(`/search?term=${term}`)
    return callback?.data
}, staleTime: 1000 * 60 * 60, gcTime: 1000 * 60 * 60 * 24 })

export default useSearch